import React from "react";

import clsx from "clsx";

import { StyledTableHeaderCell, UnsortableLabel } from "./styled";

type SortableTableHeaderProps = {
    labelKey: string;
    className?: string;
    children: React.ReactNode;
};

const UnsortableTableHeader = ({ labelKey, className, children }: SortableTableHeaderProps) => {
    return (
        <StyledTableHeaderCell
            key={`label-${labelKey}`}
            align="left"
            padding="normal"
            className={clsx("headerCell", className)}
            data-testid={`table_sort_header-button-${labelKey}`}
        >
            <UnsortableLabel>{children}</UnsortableLabel>
        </StyledTableHeaderCell>
    );
};

export default UnsortableTableHeader;
